<template id="Stage">
	<div id="Stages" class="subpage_container">
		<h2></h2>
		<div class="about second">
			<p>
				<!-- Si vous êtes jeune conducteur et donc titulaire d’un permis probatoire et que vous perdez  3 points d’un coup vous êtes dans l’obligation de faire un stage de récupération de points. Si vous avez un permis définitif vous n’êtes pas tenu de faire de stage tant qu’il vous reste des points mais il est conseillé de ne pas attendre d’avoir moins de 6 points pour s’inscrire à un stage. Sachez tout de même qu’un stage vous permet de rattraper 4 points, il est donc inutile de vous inscrire avant d’avoir perdu 4 points.<br><br>Vous avez besoin de conseil pour savoir si vous devez vous inscrire à un stage ? Contactez-nous et bénéficiez de notre expertise dans le domaine. Si vous devez effectuer un stage nous nous occupons de vous orienter vers nos partenaires, partout en France, au prix le plus avantageux pour vous. -->
				{{ txt }}
			</p>
		</div>
<!-- 		<div class="infos">
			<div class="documents">
				<div class="prix">
					<span>{{prix}}</span>
					<p>
						Tarif exceptionnel ! Dans toute la France !<br>Demandez la réservation d'un stage à {{prix}} en cliquant ci-dessous<br><br><button @click="book()">Demander un stage à {{prix}}</button>
					</p>
				</div>
			</div>
		</div>
		<p class="about second">
		</p> -->
		<div class="infos">
			<div class="documents">
				<div class="prix">
					<h3>Nouveau ! Stage de Récupération de points à Gigean<br><br>Pré-inscription ci-dessous ou en <a href="https://zfrmz.eu/wbic2E5vC5GfAmdq9sxR" target="_blank" style="text-decoration:underline;">cliquant ici</a><br></h3>
					<h4>Prochains stages disponibles :</h4>
					<ul style="padding-bottom:20px">
  <li v-for="(stage, index) in stages" :key="index">{{ stage }}</li>
</ul>
					<iframe aria-label='PRE INSCRIPTION STAGES POINTS GIGEAN' frameborder="0" style="height:500px;width:99%;border:none;" src='https://forms.zohopublic.eu/distributionautomobilesdisco/form/PREINSCRIPTIONSTAGESPOINTSGIGEAN/formperma/m_gkKR8br8Pcl2a8OuB4QN9eA252lYwzSDUR8sFsVmg'></iframe>
					<div class="img">
<!-- 						<img src="../../assets/logo_fsp.svg">
						<img src="../../assets/logo_asp.png"> -->
					</div>
					
					<p>
						<!-- Si vous souhaitez réserver immédiatement un stage, vous pouvez le faire directement ci-dessous. Consultez les tarifs et les disponibiltés avec notre partenaire Actiroute et inscrivez vous directement en ligne<br><br> -->

						<!-- <button @click="show_actiroute = !show_actiroute">M'inscrire directement en ligne</button> -->

						<!-- <a href="http://autoecole-distribution-automobiles-discount.partenaires.actiroute.com/stage-de-recuperation-de-points-montpellier-34000" target="_blank"><button>M'inscrire directement en ligne</button></a> -->

						
					</p>
					<!-- <iframe v-if="show_actiroute" style="border:none" width="100%" height="1200px" src="http://autoecole-distribution-automobiles-discount.partenaires.actiroute.com/stage-de-recuperation-de-points-montpellier-34000"></iframe> -->
				</div>
			</div>
		</div>
		<router-view></router-view>

	<!--<router-clink to="/immatriculation/carte_grise/documents" href="#Immatriculation"><button>Voir les documents</button></router-link>-->
	</div>
</template>

<script>
import Modele from '../Modele.vue'
const fb = require('../../firebaseConfig.js')
import firebase from 'firebase'
export default {
	components:{Modele},
	name: 'Stage',
	data () {
		return {
			show_actiroute:false,
			prix:'',
			txt:'',
			stages:[]

		}
	},
	methods:{
		book(){
			this.$router.push('/conduite/stages/book')
		}
	},
	mounted () {
		if(Object.keys(this.$store.state.static).length === 0){
			firebase.auth().signInAnonymously()
      		.then(() => {
				//console.log("object empty")
				fb.db.collection('documents').doc("Stages").get()
	  			.then(res => {
		  			this.prix=res.data().prix;
		  			this.txt=res.data().txt;
		  			this.stages=res.data().stages;
		  		})
		  	});
		}else{
			//console.log("object not very empty :/")
			var doc = this.$store.state.static["Stages"]
			this.prix=doc.prix
		}
  		
	},
	destroyed () {
		this.show_actiroute=false
      	this.prix=""
	}
}
</script>

<style scoped>
	.img{
		display:flex;
		justify-content: center; /* Centre horizontalement */
  		align-items: center; /* Centre verticalement */
	}
	.img img{
		max-width: 200px;
		height: 100px;
		width: auto;
		height: auto;
		padding:20px;
	}
	/* Media query pour les écrans jusqu'à 1200px de largeur */
@media all and (max-width: 1200px) {
  .img img {
    max-width: 150px; /* Reduire la largeur maximale pour s'adapter à l'écran */
    height: auto; /* Retourner à la hauteur automatique */
    padding: 15px; /* Réduire un peu le padding pour compenser la taille réduite */
  }
}

/* Media query pour les écrans jusqu'à 800px de largeur */
@media all and (max-width: 800px) {
  .img img {
    max-width: 100px; /* Réduire encore la largeur maximale pour les écrans plus petits */
    padding: 10px; /* Réduire le padding encore plus pour compenser la taille réduite */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Stages.vue